import { Grid, Pagination, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import EmptyState from '../components/Controls/EmptyState';

import LoadingState from '../components/Controls/LoadingState';
import Page from '../components/Controls/Page';
import TicketTable from '../components/TicketTable';
import { BaseAPI } from '../utils/Api';
import { getItem } from '../utils/Helper';
import Notification from '../utils/Notification';

const Tickets = () => {
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(null);
  const [ticketList, setTicketList] = useState([]);

  useEffect(() => {
    getTicketList(1);
  }, []);

  const handlePageChange = (_, value) => {
    getTicketList(value);
    setPageCount(value);
  };

  const getTicketList = (pageCount) => {
    setLoading(true);
    BaseAPI.get(`/ticket/user/${pageCount}`, { headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` } })
      .then((res) => {
        const totalPageCount = res.data.data.count / 12;
        setPageCount(Math.ceil(totalPageCount));

        setTicketList(res.data.data.rows);
      })
      .catch((err) => {
        Notification(err?.response?.data?.message, 'error');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Page title='My Tickets'>
      <LoadingState loading={loading} />
      <Typography variant='h4' mt={2} mb={4} className='bold'>
        My Tickets
      </Typography>

      {ticketList.length > 0 ? (
        <Grid container>
          <Grid item xs={12}>
            <TicketTable info={ticketList} />
          </Grid>
        </Grid>
      ) : (
        <EmptyState message='You have no tickets 👌' />
      )}

      {pageCount > 0 && (
        <Grid container direction='row' justifyContent='center' alignItems='flex-end' my={4}>
          <Pagination count={pageCount} onChange={handlePageChange} />
        </Grid>
      )}
    </Page>
  );
};

export default Tickets;
